import { Action, createReducer, on } from '@ngrx/store';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { infoCardActions } from './info-card.actions';

export interface InfoCardItem {
  infoDescription?: string;
  icon?: string;
  value: number;
}

export interface InfoCardState {
  stats1: {
    state: ILoaderActionPayload;
    data?: InfoCardItem;
  };
  stats2: {
    state: ILoaderActionPayload;
    data?: InfoCardItem;
  };
  stats3: {
    state: ILoaderActionPayload;
    data?: InfoCardItem;
  };
  stats4: {
    state: ILoaderActionPayload;
    data?: InfoCardItem;
  };
}
const initialState: InfoCardState = {
  stats1: {
    state: {
      value: LoadingState.NONE,
    },
  },
  stats2: {
    state: {
      value: LoadingState.NONE,
    },
  },
  stats3: {
    state: {
      value: LoadingState.NONE,
    },
  },
  stats4: {
    state: {
      value: LoadingState.NONE,
    },
  },
};

const reducer = createReducer(
  initialState,
  // load 1
  on(infoCardActions.load1, (state) => ({
    ...state,
    stats1: { state: { value: LoadingState.LOADING } },
  })),
  on(infoCardActions.done1, (state, props) => ({
    ...state,
    stats1: { state: props.state, data: props.data },
  })),
  // load 2
  on(infoCardActions.load2, (state) => ({
    ...state,
    stats2: { state: { value: LoadingState.LOADING } },
  })),
  on(infoCardActions.done2, (state, props) => ({
    ...state,
    stats2: { state: props.state, data: props.data },
  })),
  // load 3
  on(infoCardActions.load3, (state) => ({
    ...state,
    stats3: { state: { value: LoadingState.LOADING } },
  })),
  on(infoCardActions.done3, (state, props) => ({
    ...state,
    stats3: { state: props.state, data: props.data },
  })),
  // load 4
  on(infoCardActions.load4, (state) => ({
    ...state,
    stats4: { state: { value: LoadingState.LOADING } },
  })),
  on(infoCardActions.done4, (state, props) => ({
    ...state,
    stats4: { state: props.state, data: props.data },
  })),
);

export function infoCardReducer(state: InfoCardState | undefined, action: Action) {
  return reducer(state, action);
}
